<template>
  <Modal nome="criarAluno">
    <Campo tipo="text" placeholder="Ex: João Silva" completar="false" label="Nome do aluno" v-model="state.nome" />
    <Campo tipo="email" placeholder="email@email.com" completar="false" label="E-mail de acesso" v-model="state.email" />
    <Campo tipo="tel" placeholder="(00) 00000-0000" completar="false" label="Whatsapp do Aluno" mascara="(##) #####-####" v-model="state.whatsapp" />

    <div class="senha">
      <p>Senha do aluno será a padrão dê sua área, enviaremos para ele o acesso no e-mail</p>
      <h3>{{ storeAreas.area?.senhaPadraoAlunos }}</h3>
    </div>

    <BotaoPrincipal nome="Criar aluno" :disabled="state.loading" @click="criarAluno" />
  </Modal>
</template>

<script setup>
import { reactive, inject, onMounted } from 'vue'
import { useStoreAreas, useStoreAlunos, useStoreModal } from '@stores'
import Campo from '@components/global/elementos/Campo.vue'
import BotaoPrincipal from '@components/global/elementos/BotaoPrincipal.vue'
import Modal from '@components/global/modal/Modal.vue'

const emitter = inject('emitter')
const storeAreas = useStoreAreas()
const storeAlunos = useStoreAlunos()
const storeModal = useStoreModal()

const state = reactive({
  nome: '',
  whatsapp: '',
  email: '',
  loading: false
})

async function criarAluno() {
  if (!validarDados()) return
  state.loading = true

  const idArea = storeAreas.area?._id

  const payload = {
    nome: state.nome,
    email: state.email,
    contato: {
      whatsapp: state.whatsapp
    }
  }

  const adicionadoOk = await storeAlunos.adicionar(idArea, payload)
  if (adicionadoOk !== true) return

  emitter.emit('atualizarAlunos')
  storeModal.fecharModal('criarAluno')
  state.loading = false
  limparCampos()
}

function limparCampos() {
  state.nome = ''
  state.email = ''
  state.senha = ''
  state.whatsapp = ''
}

function validarDados() {
  let mensagem
  if (!state.nome || !state.email || !state.whatsapp) mensagem = 'Preencha todos os campos obrigatórios'
  else return true

  emitter.emit('mostrarAlerta', { tipo: 'negativo', mensagem: mensagem })
  return false
}

onMounted(() => {
  emitter.on('limparCampos', limparCampos)
})
</script>

<style scoped>
.campo {
  margin: 0 0 15px 0;
}
.senha {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  width: 100%;
  border: 1px dashed var(--cor-escuro-4);
  border-radius: 10px;
  padding: 30px 0;
  margin: 0 0 15px 0;
}
.senha p {
  font-family: var(--regular);
  font-size: var(--f2);
  color: var(--cor-escuro-6);
  line-height: 1.5;
  width: 100%;
  max-width: 300px;
}
.senha h3 {
  font-family: var(--bold);
  font-size: var(--f3);
  color: var(--cor-marca);
  line-height: 1.5;
  margin: 10px 0 0 0;
}
@media screen and (max-width: 1000px) {
}
</style>
